import { Action, createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { AutomationFlowConfig } from '../../interfaces/automation-flow-config.interface';
import { AutomationRule } from '../../interfaces/automation-rule.interface';

export interface AutomationState {
  flowConfigurations: AutomationFlowConfig[];
  flowRulesLoading: boolean;
  flowRules: AutomationRule[];
}

export const initialState: AutomationState = {
  flowConfigurations: [],
  flowRulesLoading: true,
  flowRules: []
};

const automationReducer = createReducer(
  initialState,
  on(actions.GetFlowConfigurationsSuccess, (state, payload) => ({
    ...state,
    flowConfigurations: payload.configs,
  })),
  on(actions.GetFlowRules, (state, payload) => ({
    ...state,
    flowRulesLoading: true,
    flowRules: [],
  })),
  on(actions.GetFlowRulesSuccess, (state, payload) => ({
    ...state,
    flowRulesLoading: false,
    flowRules: payload.rules,
  })),
  on(actions.GetFlowRulesFail, (state, payload) => ({
    ...state,
    flowRulesLoading: false,
    flowRules: [],
  })),
  on(actions.SaveRule, (state, payload) => ({
    ...state,
    flowRulesLoading: true,
  })),
  on(actions.SaveRuleSuccess, (state, payload) => ({
    ...state,
    flowRulesLoading: false,
    flowRules: (() => {
      const existingRuleIndex = state.flowRules.findIndex(
        r => r.id === payload.rule.id
      );

      if (existingRuleIndex !== -1) {
        return state.flowRules.map((rule, index) =>
          index === existingRuleIndex
            ? payload.rule
            : rule
        );
      } else {
        return [...state.flowRules, payload.rule];
      }
    })(),
  })),
  on(actions.SaveRuleFail, (state, payload) => ({
    ...state,
    flowRulesLoading: false,
  })),
  on(actions.DeleteRule, (state, payload) => ({
    ...state,
    flowRulesLoading: true,
  })),
  on(actions.DeleteRuleSuccess, (state, payload) => ({
    ...state,
    flowRulesLoading: false,
    flowRules: state.flowRules.filter(r => r.id != payload.id),
  })),
  on(actions.DeleteRuleFail, (state, payload) => ({
    ...state,
    flowRulesLoading: false,
  })),
  on(actions.SetDryRunStatus, (state, payload) => ({
    ...state,
    flowRulesLoading: true,
  })),
  on(actions.SetDryRunStatusSuccess, (state, payload) => ({
    ...state,
    flowRulesLoading: false,
    flowRules: [
      ...state.flowRules.map(r => {
        if (r.id == payload.id) {
          return {
            ...r,
            dryRun: payload.dryRun
          };
        }
        return r;
      }),
    ],
  })),
  on(actions.SetDryRunStatusFail, (state, payload) => ({
    ...state,
    flowRulesLoading: false,
  })),
);

export function reducer(state: AutomationState | undefined, action: Action): AutomationState {
  return automationReducer(state, action);
}
